import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { IOrderMSTeamMember } from '~/types/order/models'
import { getTeamMemberDataById } from '~/api/msw/api/teamMembers/mockData'

const orderMSTeamMemberListData = undefined as unknown as IOrderMSTeamMember[]

export const getOrderMSTeamMemberListData = getListDataFunctionFactory<
  IOrderMSTeamMember[]
>({
  listData: orderMSTeamMemberListData,
  storageKey: 'ordermsteammembers',
  getStartingListData: getStartingOrderMSTeamMemberListData,
})

export async function getOrderMSTeamMemberListDataByMOMSId(id: TEntityId) {
  const listData = await getOrderMSTeamMemberListData()
  return listData.filter(
    (omstm: IOrderMSTeamMember) => omstm.orderMasterService.id === id
  )
}

export async function getOrderMSTeamMemberDataById(
  id: TEntityId
): Promise<IOrderMSTeamMember | undefined> {
  const listData = await getOrderMSTeamMemberListData()
  return listData.find((otm: IOrderMSTeamMember) => otm.id === id)
}

export async function getStartingOrderMSTeamMemberListData(): Promise<
  IOrderMSTeamMember[]
> {
  return [
    {
      id: 'XXORDMSTM0006',
      hrid: 'ORDMSTM0006',
      orderMasterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
      },
      teamMember: await getTeamMemberDataById('XXTM0006')!,
      status: {
        id: 2,
        label: 'Active',
      },
      splitFraction: 0,
      version: '1',
      canBeDeleted: true,
    },
  ]
}
